"use strict";
// Copyright (c) 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventbusType = void 0;
exports.EventbusType = Symbol.for('IEventbus');
